// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import TreemapSvg from '@rsuite/icon-font/lib/charts/Treemap';
var Treemap = createSvgIcon({
  as: TreemapSvg,
  ariaLabel: 'treemap',
  category: 'charts',
  displayName: 'Treemap'
});
export default Treemap;